import { CollectResponseV6 } from 'app/bankid';
import { Field } from 'app/interfaces/fields';
import { IDropdownChain } from 'app/main/shared/shared-elements/dynamic-category-select/dynamic-category-select.component';
import { IColumnSettings } from 'app/main/shared/shared/table/components/custom-columns-settings/column-settings';
import { RoleDetail, User } from 'app/main/signing-pages/signing-page/signing-page.dto';
import { IAuditInterface, IAuditWithUserInterface } from '../../../global/audit.interface';
import { IGetCategoriesItemDto } from '../categories.dto';
import { Sectionable } from '../contract-control/contract-control.dto';
import { IPinnedField } from '../documents/document-right-sidebar/custom-columns';
import { ConfirmationTypeEnum } from '../general-editor-tabs/recipients-tab/recipient-tab.dto';
import { IBrandingDto } from '../settings/branding/branding.dto';
import { ICompanySettingDTO } from '../settings/company/company-settings.dto';
import { ICustomFieldDto, IMetadataItemDto, ValidationTypeEnum } from '../settings/documentfields/metadata-item.dto';
import { ISection } from '../settings/documenttype/document-type-settings-modal/document-type-settings.dto';
import { TemplateType } from '../templates/template.dto';
import { StepEnum, StepStatusEnum } from './eform-steps.dto';



export interface Template {
  id: number
  template_id?: number
  template_name?: string
  user_id: number
  workspace_id: number
  name: string
  content: string
  can_edit?: boolean
  eform_message: string
  status: number
  visible_name: string
  language: string
  signing_deadline: string
  signing_reminder: string
  recurring: number
  invitation_message: string
  section_name: string;
  confirmation_message: string
  document_key: number
  dk_type: string
  dk_password: string
  dk_password_hint: string
  dk_send_via_sms: number
  save_to_folder: number
  folders_id?: number
  allow_chat: number
  currency?: string
  attach_video: number
  video_type: string
  video_url: string
  video_title: string
  document_type_id: number
  category_id: number
  active_bcc?: number | boolean
  allow_upload_file?: number | boolean
  sender_confirmation_type?: ConfirmationTypeEnum
  created_at: string
  updated_at: string
  thumbnail: string
  template_settings: TemplateSettings
  convert_to_eform_settings: ConvertToEformSettings
  recipient_roles: RecipientRole[] | RoleDetail
  template_roles: RecipientRole[]
  fields_datas: FieldsDatas
  bcc_emails: string,
  type: TemplateType,
  code?: string
  user: User
  uploaded_pdf?: string,
  selected_categories: IDropdownChain[]
  categories?: IGetCategoriesItemDto[]
  branding?: IBrandingDto,
  company?: ICompanySettingDTO
}

export interface TemplateSettings extends  IAuditInterface{
  currency: string;
  id: number
  template_id: number
  convert_to_eform: number
  is_share: number
  active_bcc: number
  description: string
  sender_confirmation_type?: ConfirmationTypeEnum
  created_at: string
  updated_at: string
  allow_upload_file?: boolean;
}

export interface ConvertToEformSettings extends IAuditInterface {
  id: number
  template_id: number
  redirect_url_setting: number
  redirect_url: string
  participant: number
  backround: number
  arrows: number
  quick_forms: number
  quick_form_image: string
  quick_form_description: string
  quick_form_custom_message: string
  quick_form_header: number
  user_convert_to_eform_settings: Users[]
  logo_type: LogoTypeEnum
  title_settings: number
  title: string
  description_settings: number
  description: string
  term_and_condition_settings: number
  term_and_condition_content: string
  brand_color: string
  eform_steps: Steps[]
  unique_id: string
  created_at: string
  updated_at: string
}

export interface Steps {
  id: number,
  convert_to_eform_setting_id: number | null,
  heading: string,
  subheading: string,
  key: StepEnum,
  order: number,
  status: StepStatusEnum
}

export interface Users {
  user_id: number
  convert_to_eform_setting_id: number
  name: string
}

export interface SharedTemplate {
  id: number
  shareable_type: string
  shareable_id: number
  name: string
  email: string
}

export interface RecipientRole extends Partial<IAuditWithUserInterface> {
  id?: number
  old_id?: number
  user_id?: number
  template_id?: number
  workspace_id?: number
  recipient_id?: number
  organization_id?: number
  roleable_id?: number
  roleable_type?: string
  role_name?: string
  role_color?: string
  sender_as_role?: number
  invitation_type?: string
  invitation_order?: number
  authentication_type?: string
  authentication_required?: boolean
  confirmation_type?: string
  signature_confirmation?: string
  is_default?: number
  last_unread_notification_ts?: string
  created_at?: string
  updated_at?: string
  personfields?: Personfield[]
  orgfields?: Orgfield[]
  recipient?: Recipient
  organization?: Organization,
  lock?: number
  third_party_auth_response?: null | CollectResponseV6,
  eid_reference?: string | null,
  allow_to_read?: number | boolean,
  allow_to_forward?: number | boolean,
  allow_to_invite?: number | boolean,
}

export interface Personfield extends Partial<IAuditWithUserInterface> {
    id?: number
    old_id?: number
    user_id?: number
    workspace_id?: number
    recipient_role_id?: number
    type?: string
    name?: string
    key?: string
    value?: string
    is_enable?: number
    is_default?: number
    required?: number
    validation?: number
    api_attribute?: string
    hint?: string
    created_at?: string
    updated_at?: string
    validations?: Validations
    lock?: number
    metadata_id?: number
    metadata_type?: string
}

export interface PhoneValue {
  number?: string
  internationalNumber?: string
  nationalNumber?: string
  e164Number?: string
  countryCode?: string
  dialCode?: string
}

export interface Validations extends Partial<IAuditWithUserInterface> {
    id?: number
    user_id?: number
    workspace_id?: number
    recipient_role_extrafield_id?: number
    fieldable_id?: number
    fieldable_type?: string
    min?: number
    max?: number
    decimals?: number
    regular_expression?: string
    validation_help_text?: string
    validation_type?: ValidationTypeEnum
    number_validation_type?: string
    created_at?: string
    updated_at?: string
}

export interface Orgfield extends Partial<IAuditWithUserInterface>{
  id?: number
  old_id?: number
  user_id?: number
  workspace_id?: number
  recipient_role_id?: number
  type?: string
  name?: string
  key?: string
  value?: string | { name: string }
  is_enable?: number
  is_default?: number
  required?: number
  validation?: number
  api_attribute?: string
  hint?: string
  created_at?: string
  updated_at?: string
  validations?: Validations
  lock?: number
  metadata_id?: number
  metadata_type?: string
}



export interface Validations2 extends Partial<IAuditWithUserInterface> {
  id?: number
  user_id?: number
  workspace_id?: number
  recipient_role_extrafield_id?: number
  fieldable_id?: number
  fieldable_type?: string
  min?: number
  max?: number
  decimals?: number
  regular_expression?: string
  validation_help_text?: string
  validation_type?: ValidationTypeEnum
  number_validation_type?: string
  created_at?: string
  updated_at?: string
}

export interface Recipient extends Partial<IAuditWithUserInterface> {
  id?: number
  user_id?: number
  workspace_id?: number
  recipient_role_id?: number
  type?: string
  name?: string
  value?: string | { name?: string }
  is_enable?: number
  is_default?: number
  required?: number
  validation?: number
  api_attribute?: string
  created_at?: string
  updated_at?: string
  validations?: Validations
  reusable_attachments?: ReusableAttachment
  custom_fields?: ICustomFieldDto[]
}

export interface ReusableAttachment {
  id: number;
  recipient_role_id: number;
  attachment_name: string;
  attachable_id: number;
  attachable_type: string;
  meta_data_id: number;
  file_name: string;
  file_path: string;
  expire_on: string | null;
}

//TODO verify if it the same as src/app/main/pages/contacts/recipients/recipients.service.ts
export interface Recipient extends Partial<IAuditWithUserInterface> {
  address?: string;
  city?: string;
  created_at?: string;
  email?: string;
  firstname?: string;
  id?: number;
  lastname?: string;
  organization?: Organization;
  organization_id?: number;
  persnol_no?: string;
  phone_no?: string;
  profile_image?: string;
  updated_at?: string;
  user_id?: number;
  workspace_id?: number;
  zipcode?: string;
  reusable_attachments?: ReusableAttachment
  custom_fields?: ICustomFieldDto[]
}

export interface ISectionableRecipient extends Recipient {
  sectionable: Sectionable,
  sectionable_id: number,
  sectionable_type: string
}

export interface Organization {
  id?: number
  user_id?: number
  workspace_id?: number
  name?: string
  register_no?: string
  address?: string
  zipcode?: string
  city?: string
  phone?: string
  organization_image?: string
  created_at?: string
  updated_at?: string
  reusable_attachments?: ReusableAttachment
  custom_fields?: ICustomFieldDto[]
}

export interface FieldsDatas {
  id: number
  user_id: number
  workspace_id: number
  dataable_id: number
  dataable_type: string
  data: Data
  created_at: string
  updated_at: string
}

export interface Data { }

export interface GetLink {
  getlink: string,
  person: Recipient
}

export interface BCC {
  email: string
  subject: string
}

export interface TemplateForm {
  template: Template
  template_details: Template
  bcc: BCC,
  layout_settings: ISection
  convert_to_eform_settings: ConvertToEformSettings
  template_settings: TemplateSettings
  template_roles: RecipientRole[]
  template_fields_datas?: {
    data: FieldData
  }
  fields_data?: {
    data: FieldData
  }
  branding? : IBrandingDto
  custom_fields? : CustomFields[],
  template_owner? : ITemplateOwner
}



export interface ITemplateWithAccessLevel {
  access_level: string,
  template: TemplateForm
}


export interface ILayoutSettings {
  document_columns: IColumnSettings[]
  document_preview: DocumentPreview[]
  document_pinned_fields: IPinnedField[]
  categories: string;
}

export interface DocumentPreview {
  type: string
  label: string
  order: number
  doc_id: number
  status: number
  field_name: string
}


export interface FieldData {
  [key: string]: Field;
}


export enum PopoverSettingMenu {
  popoverSettingMenu = "POPOVERSETTINGMENU",
  contentBoxSettingMenu = "CONTENTBOXSETTINGMENU",
  formBuilderSettingMenu = "FORMBUILDERSETTINGMENU",
  pdfSettingMenu = "PDFSETTINGMENU",
  contentTableSettingMenu = "CONTENTTABLESETTINGMENU",
  productTableSettingMenu = "PRODUCTTABLESETTINGMENU",
  productTableSumamrySettingMenu = "PRODUCTTABLESUMMARYSETTINGMENU",
  attachmentSettingMenu = "ATTACHMENTSETTINGMENU",
  imageBoxSettings = 'IMAGESETTINGS',
  default = "Default",
  pageBreakSettings = "PAGEBREAKSETTINGS",
  legalHubSettings = 'LEGALHUBSETTINGS'
}

export enum LogoTypeEnum {
  primary = 'primary',
  secondary = 'secondary',
  no_logotype = 'no_logotype'
}

export interface TEventListenersOptions {
  id: string | number
  key: string
}

export enum TemplateRouteEnum {
  EditTemplate = 'edit-template',
  SendDocument = 'send-document',
}

export interface CustomFields {
  id: number;
  meta_data: IMetadataItemDto;
  meta_data_id: number;
  value: string;
}

export interface ITemplateOwner {
  id: number;
  name: string;
  email: string;
}